import './assets/base.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'
import { Constants } from './utils/enums'
import { setupChunkReloadRecovery } from './utils/chunkReloadRecovery'
const app = createApp(App)

app.use(createPinia())

setupChunkReloadRecovery()

app.use(router)
app.use(ElementPlus)

Sentry.init({
  app,
  dsn: Constants['SENTRY_DSN'],
  environment: Constants['ENV_NAME'],
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router, routeLabel: 'path' }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    // ブラウザ注入スクリプト（Chrome iOSの__gCrWeb等）由来のエラーを除外する。
    // 全フレームが自社コード外のイベントのみdropする（自社フレームを1つでも含めば送信される）。
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['hotel-lovers-omo-frontend'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  beforeSend(event) {
    const message = event.exception?.values?.[0]?.value ?? ''
    if (message.includes('runtime.sendMessage')) return null
    if (message.includes('Request aborted')) return null
    return event
  },
})

app.mount('#app')
